import { number, bool, } from 'prop-types';
import styled from 'styled-components';
import { useForm, useField } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAuth from '../../../../hooks/useAuth';
import NavigationButtons from '../NavigationButtons';
import { TitleWrapper } from '../common';

const MULTIMEDIA_TYPE_VALUES = [
  {
    id: 'single',
    label: 'Single photo',
    icon: 'images'
  },
  {
    id: 'panorama',
    label: 'Panorama',
    icon: 'street-view'
  },
  {
    id: 'video',
    label: 'Video',
    icon: 'video'
  },
];

const ALL_TYPE_VALUES = [
  ...MULTIMEDIA_TYPE_VALUES,
  {
    id: 'forest',
    label: 'Forest inventory',
    icon: 'trees'
  },
  {
    id: 'mill',
    label: 'Mill inventory',
    icon: 'industry'
  }
];

const Wrapper = styled.div`
  min-height: 350px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 8px;
  row-gap: 8px;
  /* max-width: 1100px; */
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    /* column-gap: 16px; */
  }

  @media screen and (min-width: 992px) {
    grid-template-columns: ${({showOnlyMultimedia}) => showOnlyMultimedia ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)'};
    column-gap: 16px;
  }
`;

const IconWrapper = styled.div`
  font-size: 32px;
  margin-right: 16px;

  @media screen and (min-width: 768px) {
    font-size: 44px;
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({theme, isSelected}) => isSelected ? theme.colors.brand_tint_yellow : theme.colors.bg_gray_light};
  padding: 8px;
  cursor: pointer;
  transition: background-color 500ms ease;

  &:hover {
    background-color: ${({theme}) => theme.colors.brand_tint_yellow};
  }

  span {
    text-transform: uppercase;
    text-align: center;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    padding: 16px;
  }
`;

// TODO
// - mobile view
// - fix video icon
function UploadType({
  currentStep,
  hasValidationErrors,
}) {
  const { locations } = useAuth();
  const { change } = useForm();
  const {
    input: { value: selectedType },
  } = useField(`uploadType`, {
    subscription: { value: true },
  });

  const uploadTypeOptions = (!locations || locations.length === 0) ? MULTIMEDIA_TYPE_VALUES : ALL_TYPE_VALUES;
  return (
    <Wrapper>
      <TitleWrapper>
        <p>Welcome to drone media upload</p>
        <p>
          First of all please select appropriate upload type.
        </p>
      </TitleWrapper>

      <Grid showOnlyMultimedia={!locations || locations.length === 0}>
        {
          uploadTypeOptions.map(({id, label, icon}) => (
            <Item key={id}
              isSelected={selectedType === id}
              onClick={() => {
                change('uploadType', id);
                change('currentStep', currentStep + 1);
              }}>
              <IconWrapper>
                <FontAwesomeIcon icon={['fal', `${icon}`]} />
              </IconWrapper>
              <span>{label}</span>
            </Item>
          ))
        }
      </Grid>
      <NavigationButtons
        currentStep={currentStep}
        isNextDisabled={hasValidationErrors}
        onNextClick={() => change('currentStep', currentStep + 1)} />
    </Wrapper>
  );
}

UploadType.propTypes = {
  currentStep: number.isRequired,
  hasValidationErrors: bool.isRequired,
}

export default UploadType;